<ic-root>
	<header>
		<ic-contact [supportInfo]="supportInfo()" />
	</header>
	<ic-page-filter
		data-test="page-filter"
		[departments]="departmentsQuery.data()"
		[homes]="homes()"
		[residents]="residents$ | async"
	/>
	<div class="content-wrapper" contents>
		@if (isResidentSelectionRequired()) {
			<div class="flex h-full items-center">
				<p class="w-full text-center" data-test="page-filter-required-message">
					{{ "pageFilter.required" | translate }}
				</p>
			</div>
		} @else {
			<router-outlet />
		}
	</div>
	<router-outlet name="action" />
	<router-outlet name="aside" />
</ic-root>
